import { FC, useState } from "react";
import Icon from "../Icon";
import Loading, { SpinnerSize } from "../Loading";
import { ImageCardInternalProps } from "./types";
import { styles } from "./styles";

const ImageCardInternal: FC<ImageCardInternalProps> = ({
  src,
  imageName,
  error,
  loading,
  alt
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  if (loading) {
    return (
      <div css={styles.imagePlaceholder}>
        <Loading.Spinner size={SpinnerSize.SMALL} />
      </div>
    );
  }

  if (error) {
    return (
      <div css={styles.imageError} aria-hidden="true">
        <Icon name="Warning" fill="var(--color-danger)" />
      </div>
    );
  }

  if (imageError) {
    return (
      <div css={styles.imagePlaceholder} aria-hidden="true">
        <Icon name="Image" size="medium" fill="var(--color-secondary)" />
      </div>
    );
  }

  return (
    <>
      {!imageLoaded && <div css={styles.imagePlaceholder} aria-hidden="true" />}
      <img
        src={src}
        alt={alt || imageName}
        css={[styles.imageThumbnail, !imageLoaded && styles.hidden]}
        onLoad={() => setImageLoaded(true)}
        onError={() => setImageError(true)}
      />
    </>
  );
};

export default ImageCardInternal;
